import {
  GET_TRAYS,
  GET_TRAYS_SUCCESS,
  GET_TRAYS_ERROR,
  CREATE_TRAY,
  CREATE_TRAY_SUCCESS,
  CREATE_TRAY_ERROR,
  UPDATE_TRAY,
  UPDATE_TRAY_SUCCESS,
  UPDATE_TRAY_ERROR,
  DELETE_TRAY,
  DELETE_TRAY_SUCCESS,
  DELETE_TRAY_ERROR,
  SET_ACTIVE_TRAY,
  GET_TRAY_QUEUE,
  GET_TRAY_QUEUE_SUCCESS,
  GET_TRAY_QUEUE_ERROR,
  TRAY_QUEUE_SYNC_CONTACT,
} from './traysTypes';

const initialState = {
  items: [],
  loading: false,
  error: null,
  // Cola en el chat
  activeTrayId: null,
  queue: [], // Contact[] completos de la bandeja activa
  queueCount: 0, // total de contactos en cola (badge)
  queueDepartedIds: [], // ids que salieron de la bandeja activa (dedup de salidas)
  listStaleTick: 0, // incrementa en cada movimiento de bandeja → dispara refetch del listado
  queueLoading: false,
  queueError: null,
};

const traysReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TRAYS:
      return { ...state, loading: true, error: null };
    case GET_TRAYS_SUCCESS:
      return { ...state, items: action.payload, loading: false };
    case GET_TRAYS_ERROR:
      return { ...state, loading: false, error: action.payload };

    case CREATE_TRAY:
      return { ...state, loading: true, error: null };
    case CREATE_TRAY_SUCCESS:
      return {
        ...state,
        items: state.items.some(tray => tray.id === action.payload.id)
          ? state.items
          : [...state.items, action.payload],
        loading: false,
      };
    case CREATE_TRAY_ERROR:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_TRAY:
      return { ...state, loading: true, error: null };
    case UPDATE_TRAY_SUCCESS:
      return {
        ...state,
        items: state.items.map(tray =>
          tray.id === action.payload.id ? action.payload : tray
        ),
        loading: false,
      };
    case UPDATE_TRAY_ERROR:
      return { ...state, loading: false, error: action.payload };

    case DELETE_TRAY:
      return { ...state, loading: true, error: null };
    case DELETE_TRAY_SUCCESS:
      return {
        ...state,
        items: state.items.filter(tray => tray.id !== action.payload),
        loading: false,
      };
    case DELETE_TRAY_ERROR:
      return { ...state, loading: false, error: action.payload };

    case SET_ACTIVE_TRAY: {
      // Sembrar queueCount con el contact_count ya conocido para que el chip no
      // parpadee 0→N mientras carga la cola; el fetch lo refina al llegar.
      const tray = action.payload == null
        ? null
        : (state.items || []).find(t => t.id === action.payload);
      return {
        ...state,
        activeTrayId: action.payload,
        queue: [],
        queueCount: Number.isFinite(tray?.contact_count) ? tray.contact_count : 0,
        queueDepartedIds: [],
        queueLoading: false,
        queueError: null,
      };
    }

    case GET_TRAY_QUEUE:
      return { ...state, queueLoading: true, queueError: null };
    case GET_TRAY_QUEUE_SUCCESS:
      return {
        ...state,
        queue: action.payload.items,
        queueCount: action.payload.count,
        queueLoading: false,
      };
    case GET_TRAY_QUEUE_ERROR:
      return { ...state, queueLoading: false, queueError: action.payload };

    case TRAY_QUEUE_SYNC_CONTACT: {
      const contact = action.payload?.contact;
      if (!contact?._id) return state;

      // Un movimiento real (previous_tray presente) toca DOS bandejas (origen y
      // destino). El server es la única fuente exacta de ambos conteos, así que
      // marcamos el listado como sucio para re-consultarlo; el reducer solo lleva
      // la cola de la bandeja activa.
      const s = contact.previous_tray != null
        ? { ...state, listStaleTick: (state.listStaleTick || 0) + 1 }
        : state;

      if (s.activeTrayId == null) return s;

      const id = String(contact._id);
      const active = String(s.activeTrayId);
      // queueDepartedIds marca los contactos que ya salieron de la bandeja activa:
      // el evento de bandeja no trae `id`, así que no pasa por isMessageDuplicate
      // y una reentrega idéntica no debe decrementar el badge dos veces.
      const departed = s.queueDepartedIds || [];
      const isDeparted = departed.includes(id);
      const idx = s.queue.findIndex(c => String(c._id) === id);

      const goesToActive = contact.id_tray != null && String(contact.id_tray) === active;
      const cameFromActive = contact.previous_tray != null && String(contact.previous_tray) === active;

      // Está en la página cargada de la cola activa
      if (idx >= 0) {
        if (!goesToActive) {
          // Sale de la bandeja activa → remover, decrementar y marcar la salida.
          return {
            ...s,
            queue: s.queue.filter(c => String(c._id) !== id),
            queueCount: Math.max(0, s.queueCount - 1),
            queueDepartedIds: isDeparted ? departed : [...departed, id],
          };
        }
        // Misma bandeja → merge; si había salido y volvió, limpiar la marca.
        return {
          ...s,
          queue: s.queue.map((c, i) => (i === idx ? { ...c, ...contact } : c)),
          queueDepartedIds: isDeparted ? departed.filter(x => x !== id) : departed,
        };
      }

      // No está en la página cargada y entra a la bandeja activa
      if (goesToActive) {
        return {
          ...s,
          queue: [contact, ...s.queue],
          queueCount: s.queueCount + 1,
          queueDepartedIds: isDeparted ? departed.filter(x => x !== id) : departed,
        };
      }

      // No está en la página cargada y SALE de la bandeja activa (cola paginada):
      // previous_tray identifica el origen → decrementar el badge UNA sola vez.
      if (cameFromActive && !isDeparted) {
        return {
          ...s,
          queueCount: Math.max(0, s.queueCount - 1),
          queueDepartedIds: [...departed, id],
        };
      }

      return s;
    }

    default:
      return state;
  }
};

export default traysReducer;
